import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectorRef, OnInit, OnDestroy, HostListener } from '@angular/core';
import { FormControl, FormGroupDirective, } from '@angular/forms';
import { maxBytesError, inValidDateError, futureDateError } from '../../../../shared/validators';
import { IMyDpOptions, IMyDateModel, } from 'mydatepicker';
import { Subscription } from 'rxjs';
import { FormDropdown } from './../../interface/notification-data';

@Component({
    selector: 'sm-form-field',
    template: require('./notification-form-field.component.html'),
    styles: [require('./notification-form-field.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationFormFieldComponent implements OnInit, OnChanges, OnDestroy {

    @Input()
    public controlName: string;

    @Input()
    public fieldControl: FormControl;

    @Input()
    public label: string;

    @Input()
    public placeholder: string;

    @Input()
    public dropDownList: FormDropdown[];

    @Input()
    public defaultDropDownList: FormDropdown[];

    @Input()
    public defaultValue: FormDropdown;

    @Input()
    public isDropDownField = false;

    @Input()
    public isRequired = false;

    @Input()
    public fieldInstruction = false;

    @Input()
    public showInput = true;

    @Input()
    public errorMsg = '';

    @Input()
    public errorMsgIcon = '';

    @Input()
    public customErrorMsg = '';

    @Input()
    public showLoading = false;

    @Input()
    public isDateField: boolean;

    @Input()
    public isNumberField: boolean;

    @Input()
    public displayError: boolean;

    @Input()
    public showDropDownSearch = false;

    @Input()
    public multiSelect: boolean;

    @Input()
    public showSelectAll: boolean;

    @Input()
    public isDisabled: boolean;

    @Input()
    public isViewOnly: boolean;

    @Input()
    public fieldType = 'text';

    @Input()
    public maxlength: number;

    @Input()
    public disableFutureDate: boolean;

    @Input()
    public fieldAction: string;

    @Input()
    public disableFieldAction: boolean;

    @Output()
    public onDropDownValueSelected: EventEmitter<FormDropdown> = new EventEmitter();

    @Output()
    public onDropDownValuesSelected: EventEmitter<FormDropdown[]> = new EventEmitter();

    @Output()
    public onDateEntered: EventEmitter<any> = new EventEmitter();

    @Output()
    public onValueEntered: EventEmitter<string> = new EventEmitter();

    @Output()
    public onRadioButtonValueChanged: EventEmitter<boolean> = new EventEmitter();

    @Output()
    public onFieldActionClicked: EventEmitter<any> = new EventEmitter();

    public showDropDown = false;
    public isInputFocused = false;
    public subscription: Subscription;
    public filterItems: FormDropdown[] = [];
    public checkedList: FormDropdown[] = [];
    public toolTip: string[];
    public selectAllChecked = true;

    public myDatePickerOptions: IMyDpOptions = {
        dateFormat: 'dd-mmm-yyyy',
        showTodayBtn: true,
        todayBtnTxt: 'Today'
    };

    constructor(private changedect: ChangeDetectorRef) {

    }

    public ngOnInit() {
        if (this.disableFutureDate) {
            let date: Date = new Date();
            this.myDatePickerOptions.disableSince = {
                year: date.getFullYear(),
                month: date.getMonth() + 1,
                day: date.getDate() + 1
            };
        }
        this.subscription = this.fieldControl.valueChanges.subscribe(value => {
            this.changedect.markForCheck();
        });
        this.filterItems = this.dropDownList;
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes && changes.dropDownList && this.isDropDownField) {
            this.filterItems = this.dropDownList;
            if (!this.dropDownList || this.dropDownList.length === 0) {
                this.checkedList = [];
                this.fieldControl.setValue('');
                this.onDropDownValuesSelected.emit([]);
            }
            if ((!this.defaultDropDownList || this.defaultDropDownList.length === 0) &&
                this.selectAllChecked && this.showSelectAll && this.filterItems) {
                this.filterItems.forEach(t => t.isChecked = true);
                this.checkedList = this.filterItems;
                this.fieldControl.setValue(this.checkedList.toString());
                this.onDropDownValuesSelected.emit(this.checkedList);
            }
        }
        if (changes && changes.defaultDropDownList && this.defaultDropDownList && this.isDropDownField && 
            this.multiSelect && this.filterItems) {
            this.selectAllData();
        }
        if (changes && changes.defaultDropDownList && this.defaultDropDownList && this.isDropDownField &&
            !this.multiSelect && this.filterItems) {
            this.filterItems.forEach(item => {
                let index = this.defaultDropDownList.findIndex(t => t.key === item.key);
                if (index !== -1) {
                    item.isChecked = true;
                } else {
                    item.isChecked = false;
                }
            });
        }
        if (changes && changes.defaultValue && this.isDropDownField && !this.multiSelect && this.filterItems) {
            if (!this.defaultValue) {
                this.filterItems.forEach(t => t.isChecked = false);
            } else {
                this.fieldControl.setValue(this.defaultValue.value);
                this.filterItems.forEach(t => {
                    t.isChecked = t.value === this.defaultValue.value ? true : false;
                });
            }
        }
        if (this.checkedList && this.checkedList.length > 1) {
            this.toolTip = this.checkedList.slice(1).map(data => '  ' + data.value);
        }
    }

    public ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    @HostListener('document:click', ['$event.target'])
    public onOutsideClick(targetElement: HTMLElement) {
        if (this.controlName && targetElement && 
            (targetElement.className !== `drop-show ${this.controlName} active-list`) &&
            (targetElement.className !== `material-icons ${this.controlName}`) &&
            (targetElement.offsetParent &&
            targetElement.offsetParent.className.indexOf('drop-show') === -1)) {
            const isSelectMenuActive = document.getElementsByClassName(`drop-show ${this.controlName} active-list`).length;
            if (isSelectMenuActive) {
                this.showDropDown = false;
            }
        }
    }

    public fieldActionClicked() {
        this.onFieldActionClicked.emit({ key: this.controlName, control: this.fieldControl });
    }

    public onItemChange() {
        this.showDropDown = false;
        this.fieldControl.setValue('');
        if (this.isDropDownField && this.dropDownList) {
            this.dropDownList.forEach(t => t.isChecked = false);
        }
        this.filterItems = this.dropDownList;
        this.checkedList = [];
        this.selectAllChecked = false;
        this.onDropDownValueSelected.emit(null);
        this.onDropDownValuesSelected.emit(this.checkedList);
    }

    public dropDownItemClicked(item: FormDropdown) {
        this.filterItems.forEach(t => {
            t.isChecked = t.key === item.key;
        });
        this.fieldControl.setValue(item.value);
        this.fieldControl.markAsTouched();
        this.showDropDown = false;
        this.onDropDownValueSelected.emit(item);
    }

    public onScheduledChange($event: IMyDateModel) {
        this.fieldControl.setValue($event.formatted);
        this.onDateEntered.emit($event.formatted);
    }

    public unSelectAll() {
        this.selectAllChecked = !this.selectAllChecked;
        this.fieldControl.markAsTouched();
        if (this.selectAllChecked) {
            this.filterItems.forEach(t => t.isChecked = true);
            this.checkedList = this.filterItems;
            this.fieldControl.setValue(this.checkedList.toString());
        } else {
            this.checkedList = [];
            this.filterItems.forEach(t => t.isChecked = false);
            this.fieldControl.setValue('');
        }
        this.onDropDownValuesSelected.emit(this.checkedList);
    }

    public getSelectedValue(item: FormDropdown, isChecked: boolean) {
        item.isChecked = isChecked;
        if (isChecked) {
            this.checkedList.push(item);
        } else {
            this.checkedList = this.checkedList.filter(cl => cl.key !== item.key);
        }
        if (this.checkedList && this.checkedList.length > 1) {
            this.toolTip = this.checkedList.slice(1).map(data => '  ' + data.value);
        } else {
            this.toolTip = [];
        }
        this.selectAllChecked = this.checkedList.length === this.dropDownList.length && this.showSelectAll;
        this.fieldControl.setValue(this.checkedList.toString());
        this.fieldControl.markAsTouched();
        this.onDropDownValuesSelected.emit(this.checkedList);
    }

    public IsInvalidField() {
        if (this.fieldControl.touched || this.fieldControl.value || this.displayError) {
            if (this.fieldControl.hasError('required') || (this.isRequired && !this.fieldControl.value)) {
                this.customErrorMsg = this.label + ' is required.';
                return true;
            }
            if (this.fieldControl.hasError('pattern') && this.isNumberField && this.fieldControl.value) {
                this.customErrorMsg = 'Please enter a valid number';
                return true;
            }
            if (this.fieldControl.hasError(maxBytesError)) {
                this.customErrorMsg = 'Field exceeds maximum characters.';
                return true;
            }
            if (this.controlName === 'scheduledShipmentDate' && this.fieldControl.hasError('pattern')) {
                this.customErrorMsg = 'Please enter date in the format: DD-MMM-YYYY.';
                return true;
            }
            if (this.fieldControl.hasError('pattern') || this.fieldControl.hasError(inValidDateError)) {
                this.customErrorMsg = this.label ? 'Please enter valid ' + this.label + '.' :
                    'Please enter valid format.';
                return true;
            }
            if (this.isDateField && this.fieldControl.hasError(futureDateError)) {
                this.customErrorMsg = this.label + ' should not be greater than the entry date.';
                return true;
            }
        }
        this.customErrorMsg = '';
        return false;
    }

    public onSearchBoxChange(searchText: string) {
        this.filterItems = this.dropDownList.filter(item => item.value.toLowerCase().indexOf(searchText.toLowerCase()) !== -1);
    }

    public handleChange(value: boolean) {
        this.fieldControl.setValue(value);
        this.onRadioButtonValueChanged.emit(value);
    }

    private selectAllData() {
        if (this.defaultDropDownList && this.defaultDropDownList.length === this.dropDownList.length) {
            this.checkedList = this.dropDownList;
            this.checkedList.forEach(t => t.isChecked = true);
            this.filterItems = this.checkedList;
            this.fieldControl.setValue(this.checkedList.toString());
            return;
        }
        //this.selectAllChecked = false;
        this.checkedList = this.defaultDropDownList;
        this.checkedList.forEach(t => t.isChecked = true);
        this.fieldControl.setValue(this.checkedList.toString());
        this.filterItems.forEach(item => {
            let index = this.checkedList.findIndex(t => t.value === item.value);
            if (index !== -1) {
                item.isChecked = true;
            } else {
                item.isChecked = false;
            }
        });
    }
}